import {
  OnFetchFilteredPackagesError,
  OnFetchFilteredPackagesStart,
  OnFetchFilteredPackagesSuccess,
  OnFilteredFetched,
  OnFiltersFetchStarted,
  OnInitFilters,
  OnResetDepartureDateFlexibility,
  OnResetDepartureDateOffset,
  OnResetDepartureFiltersSettings,
  OnResetFilters,
  OnSelectDepartureDateOffset,
  OnSelectDepartureFlexibility,
  OnSelectFilters,
  OnSelectTransportation
} from './filters.types'

export const FETCH_FILTERS_STARTED = 'FETCH_FILTERS_STARTED'
export const FILTERS_FETCHED = 'FILTERS_FETCHED'
export const INIT_FILTERS = 'INIT_FILTERS'
export const RESET_FILTERS = 'RESET_FILTERS'
export const SELECT_FILTERS = 'SELECT_FILTERS'
export const SELECT_TRANSPORTATION = 'SELECT_TRANSPORTATION'
export const ON_FILTERED_PACKAGES_FETCHED_START = 'ON_FILTERED_PACKAGES_FETCHED_START'
export const ON_FILTERED_PACKAGES_FETCHED_SUCCESS = 'ON_FILTERED_PACKAGES_FETCHED_SUCCESS'
export const ON_FILTERED_PACKAGES_FETCHED_ERROR = 'ON_FILTERED_PACKAGES_FETCHED_ERROR'

export const RESET_DEPARTURE_DATE_OFFSET = 'RESET_DEPARTURE_DATE_OFFSET'
export const RESET_DEPARTURE_DATE_FLEXIBILITY = 'RESET_DEPARTURE_DATE_FLEXIBILITY'
export const RESET_DEPARTURE_FILTERS_SETTINGS = 'RESET_DEPARTURE_FILTERS_SETTINGS'
export const SELECT_DEPARTURE_DATE_OFFSET = 'SELECT_DEPARTURE_DATE_OFFSET'
export const SELECT_DEPARTURE_FLEXIBILITY = 'SELECT_DEPARTURE_FLEXIBILITY'

export const onFiltersFetched: OnFilteredFetched = products => ({
  payload: {
    products
  },
  type: FILTERS_FETCHED
})

export const onFiltersFetchStarted: OnFiltersFetchStarted = () => ({
  type: FETCH_FILTERS_STARTED
})

export const onResetFilters: OnResetFilters = () => ({
  type: RESET_FILTERS
})

export const onInitFilters: OnInitFilters = (departureCities, departureDates, durations, transportation) => ({
  payload: {
    departureCities,
    departureDates,
    durations,
    transportation
  },
  type: INIT_FILTERS
})

export const onSelectFilters: OnSelectFilters = selectedFilters => ({
  payload: { selectedFilters },
  type: SELECT_FILTERS
})

export const onSelectTransportation: OnSelectTransportation = selectedTransportation => ({
  payload: { selectedTransportation },
  type: SELECT_TRANSPORTATION
})

export const onResetDepartureDateFlexibility: OnResetDepartureDateFlexibility = () => ({
  type: RESET_DEPARTURE_DATE_FLEXIBILITY
})

export const onResetDepartureDateOffset: OnResetDepartureDateOffset = () => ({
  type: RESET_DEPARTURE_DATE_OFFSET
})

export const onResetDepartureFiltersSettings: OnResetDepartureFiltersSettings = () => ({
  type: RESET_DEPARTURE_FILTERS_SETTINGS
})

export const onSelectDepartureFlexibility: OnSelectDepartureFlexibility = departureDateFlexibility => ({
  payload: { departureDateFlexibility },
  type: SELECT_DEPARTURE_FLEXIBILITY
})

export const onSelectDepartureDateOffset: OnSelectDepartureDateOffset = departureDateOffset => ({
  payload: { departureDateOffset },
  type: SELECT_DEPARTURE_DATE_OFFSET
})

export const onFetchFilteredPackagesSuccess: OnFetchFilteredPackagesSuccess = (productKey, packages) => ({
  payload: {
    packages,
    productKey
  },
  type: ON_FILTERED_PACKAGES_FETCHED_SUCCESS
})

export const onFetchFilteredPackagesStart: OnFetchFilteredPackagesStart = () => ({
  type: ON_FILTERED_PACKAGES_FETCHED_START
})

export const onFetchFilteredPackagesError: OnFetchFilteredPackagesError = () => ({
  type: ON_FILTERED_PACKAGES_FETCHED_ERROR
})
